// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   AI Statistics Skeleton — tab content area
   Mirrors kpi-grid + data table from ai-statistics.component
   ========================================================= */

.skl-stats-content {
  padding: 16px 0;
}

/* ── KPI grids ── */
.skl-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 4px;
}

.skl-kpi-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.skl-kpi-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.skl-kpi-card__content {
  flex: 1;
}

.skl-kpi-card__icon {
  margin-left: 8px;
  flex-shrink: 0;
}

/* ── Data table card ── */
.skl-table-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  overflow: hidden;
}

.skl-table-card__header {
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.skl-table-head-row,
.skl-table-data-row {
  display: flex;
  align-items: center;
}

.skl-table-head-row {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  min-height: 44px;
}

.skl-table-data-row {
  border-bottom: 1px solid #f0f0f0;
  min-height: 44px;
}

.skl-table-data-row:last-child {
  border-bottom: none;
}

.skl-table-cell {
  flex: 1;
  padding: 0 12px;
}

.skl-table-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #dee2e6;
}

/* Responsive */
@media (max-width: 767.98px) {
  .skl-kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-statistics/ai-statistics-skeleton/ai-statistics-skeleton.component.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* =========================================================\n   AI Statistics Skeleton — tab content area\n   Mirrors kpi-grid + data table from ai-statistics.component\n   ========================================================= */\n\n.skl-stats-content {\n  padding: 16px 0;\n}\n\n/* ── KPI grids ── */\n.skl-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.skl-kpi-grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.skl-kpi-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,.06);\n}\n\n.skl-kpi-card__content {\n  flex: 1;\n}\n\n.skl-kpi-card__icon {\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n/* ── Data table card ── */\n.skl-table-card {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 1px 3px rgba(0,0,0,.06);\n  overflow: hidden;\n}\n\n.skl-table-card__header {\n  padding: 10px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.skl-table-head-row,\n.skl-table-data-row {\n  display: flex;\n  align-items: center;\n}\n\n.skl-table-head-row {\n  background: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n  min-height: 44px;\n}\n\n.skl-table-data-row {\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 44px;\n}\n\n.skl-table-data-row:last-child {\n  border-bottom: none;\n}\n\n.skl-table-cell {\n  flex: 1;\n  padding: 0 12px;\n}\n\n.skl-table-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  border-top: 1px solid #dee2e6;\n}\n\n/* Responsive */\n@media (max-width: 767.98px) {\n  .skl-kpi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
